import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import LoggerUtils from "../../utils/logger/LoggerUtils";
import TextConstants from "../../utils/constants/TextConstants";
// import { getAccessToken } from "./userThunks";

export const getAllOnGoingCarTransactions = createAsyncThunk(
  "carTransactions/getAllOnGoingCarTransactions",
  async (_, { rejectWithValue }) => {
    try {
      // const token = getAccessToken();
      const response = await axios.get(
        TextConstants.ALL_CAR_TRANSACTIONS_ENDPOINT,
        {
          headers: {
            accept: "application/json",
            // authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      LoggerUtils.logError("Error fetching ongoing car transactions", error);
      return rejectWithValue(error.message);
    }
  }
);
